module.exports = __webpack_public_path__ + "static/img/order-mobile-4.69a4a22f.png";